<template>
  <div class="advantages">
    <h2 class="advantages__title">Vantaggi</h2>

    <ul class="advantages__list">
      <li v-for="advantage in advantages" :key="advantage" class="advantages__item">
        <vb-icon
          class="advantages__icon"
          :name="'check-circle'"
          :color="sass('success')"
          :size="20"
        />
        {{ advantage }}
      </li>
    </ul>
  </div>
</template>

<script>
  import { VALIDITY_MONTHS } from '@livegift/resources';

  export default {
    name: 'advantages',

    data() {
      return {
        // vantaggi della gift card, uguali per tutti i prodotti (testi dal Figma)
        advantages: [
          'Valida per prenotare in tutto il mondo.',
          `Blocchi il valore oggi e decidi le tue date di viaggio entro ${VALIDITY_MONTHS} mesi.`,
          'Credito a scalare: utilizzabile anche per più prenotazioni distinte.',
          'Se il viaggio costa più dell’importo della card, puoi integrare con carta di credito.',
          'Nessun costo nascosto.',
        ],
      };
    },
  };
</script>

<style lang="scss" scoped>

  .advantages {

    &__title {
      margin: 0;
      font-size: $font-size-xl;
      font-weight: $vb-font-weight-semibold;
      line-height: 27px;
      color: $gray-900;
    }

    &__list {
      margin: 0;
      padding: 0;
      list-style: none;
    }

    &__item {
      display: flex;
      align-items: center;
      margin-top: $grid-gutter-width / 3;
      font-size: $font-size-md;
      line-height: 20px;
      color: $gray-900;
    }

    &__icon {
      flex-shrink: 0;
      margin-right: $grid-gutter-width / 3;
    }
  }
</style>